<app-last-reg [projectId]="projectId" [formId]="formId" [lastRefresh]="lastUpdate"></app-last-reg>
